import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import indefinite from 'indefinite';
import { DOMAIN_ORGANIZATION, DOMAIN_ORGANIZATION_LOWER, DOMAIN_SEASON, DOMAIN_SEASON_LOWER } from '../../../constants/domainCopy';

import { ToolTip } from '../../../components/overlays';

import './index.scss';

interface PublicJoinTooltipProps {
    restrictRegistrationToWhitelistedDomains: boolean;
}

const PublicJoinTooltip = (props: PublicJoinTooltipProps) => {
    const { restrictRegistrationToWhitelistedDomains } = props;
    
    

    return (
        <ToolTip trigger={<FontAwesomeIcon icon={['fas', 'circle-info']} size="1x" />}>
            <>
                <div>Turning this option on will:</div>
                <ul>
                    <li>
                        Display a public join button on this {DOMAIN_ORGANIZATION_LOWER}'s page to users who are
                        not logged in
                    </li>
                    <li>
                        Allow anyone{' '}
                        {restrictRegistrationToWhitelistedDomains
                            ? 'with an email address in the list of allowed email domains'
                            : 'on the internet'}{' '}
                        to join this {DOMAIN_ORGANIZATION_LOWER} when signing up for{' '}
                        {indefinite(DOMAIN_SEASON_LOWER)} (if they aren't already a member)
                    </li>
                </ul>
            </>
        </ToolTip>
    );
};

export default PublicJoinTooltip;
